import { Typography } from "@mui/material";
import { useContext } from "react";
import CardBox from "../../../main/components/CardBox";
import { MainContext } from "../../../main/context/MainContextProvider";

type ListItemProps = {
  startDate: string;
  endDate: string;
  status: string;
  tipo: string;
};

export default function ListItem({
  startDate,
  endDate,
  status,
  tipo,
}: ListItemProps) {
  const { isMobile } = useContext(MainContext);
  return (
    <>
      <CardBox>
        <Typography
          sx={{
            fontSize: { xs: "13px", sm: "17px" },
            textAlign: "left",
          }}
        >
          {startDate}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "13px", sm: "17px" },
            textAlign: "left",
          }}
        >
          {endDate}
        </Typography>
        <Typography
          sx={{
            display: screen.width < 386 ? "none" : undefined,
            fontSize: { xs: "13px", sm: "17px" },
            textAlign: "left",
          }}
        >
          {status}
        </Typography>
        <Typography
          sx={{
            display: isMobile ? "none" : undefined,
            fontSize: { xs: "13px", sm: "17px" },
            textAlign: "left",
          }}
        >
          {tipo}
        </Typography>
      </CardBox>
    </>
  );
}
